module.exports = __webpack_public_path__ + "static/banner-a907a925435b7ab049dc5a7215d577d1.png";